function BaseController(){
	this.className			= "BaseController";
	this.glob				= "/**";
	this.priority			= 10000;
	this.debug				= false;
	this.views				= false;
};
BaseController.inheritsFrom( StandardController );
BaseController.prototype.swapMain = function(onComplete){

	//console.log("SWAP MAIN?")

	if(!this.isSetup){
		//console.log("SWAP MAIN SETUP?")
		this.$body 				= $("body");
		this.$scrollElement		= $("body, html");	// what to scroll when navigating with aviator
		this.$header			= this.$body.find(".js-header");
		this.$jsBody			= this.$body.find(".js-body");
		this.$page 				= this.$jsBody.find(".js-page");

		const theme = (this.$body.attr("class").match(/theme\-[a-z]+/)||[""])[0];
		console.log("THEME ",theme);
		this.$cover = $(`<div class="js-cover ${theme}" style="pointer-events:none;z-index:2;width:100%;height:100%;position:fixed;"></div>`);
		this.$jsBody.before(this.$cover);

		jcache.setImagesSrcWait(this.$jsBody);

		this.linkup = new Linkup();
	}

	if(this.views){
		this.runViews(onComplete);
	}else{
		this.runDefault(onComplete);
	}

	return false;
};
BaseController.prototype.runDefault = function(onComplete){

	// setting up aviator stage for the first time
	if(!this.isSetup) {
		this.isSetup = true;
	}else{

		// LOAD PAGE CACHE
		const state = nav.getState();
		const cache = jcache.getCache(state.nextUrl);
		//console.log(cache)
		const $page = cache.$get(".js-body",false);
		this.$jsBody = this.$body.find(".js-body"); // refresh this in case another page has messed with it!
		this.$jsBody.html($page);

		const match = cache.raw.match(/<body[^>]*?class="([a-zA-Z0-9\-_\s]+)"[^>]*>/);
		let bodyClass = match ? match[1] : "";

		// Add data-BodyClass to body class.
		const dataBodyClass = this.$jsBody.find('.js-page').attr('data-bodyClass');
		if(dataBodyClass){
			bodyClass = `${bodyClass} ${dataBodyClass}`;
		}

		//console.log(bodyClass)

		this.$body.attr("class",bodyClass);

		// scroll to top when navigating to new page
		this.$scrollElement.scrollTop(0);

	}

	// elements that need recognising after every page load (as they change)
	this.$page = this.$jsBody.find(".js-page");

	// Process images
	var imageCount = this.processImages(this.$body, onComplete);

	// Add all links to aviator
	//nav.addToLinks($("a:not(.no-auto-link)"));
	nav.addToLinks($("a"));

	onComplete();
}
BaseController.prototype.runViews = function(onComplete){

	// setting up aviator stage for the first time
	if(!this.isSetup){

		// Setup view model
		this.viewModel = new ViewModel();
		this.viewModel.addListener('ready', (e) => {
			onComplete();
		});

		this.isSetup = true;

	}else{
		onComplete();
	}

}
BaseController.prototype.swap = function(onComplete){
	return true;
};
BaseController.prototype.on = function(onComplete){
	return true;
};
BaseController.prototype.onMain = function(onComplete){
	this.linkup.run();

	this.$body.css("visibility","visible");

	if(typeof(ga) !== "undefined"){ //needs checking
		console.log('%c[baseController] send pageview', 'background:cyan', nav.getState().nextUrl)
		ga('send', 'pageview', nav.getState().nextUrl);
	}

	this.$cover.stop().animate({opacity:0},{duration:750,  complete: () => {
		//onComplete();
	}})



	return true;
}
BaseController.prototype.processImages = function($container, onComplete, rebuild = true){
	if(!$container) $container = this.$page;

	if(rebuild || !this.imageController) {
		this.imageController = new ImageController();
	}

	if(onComplete) this.imageController.addListener("ready",Igloo.delegate(this, function(){
		onComplete();
	}));
	var imageCount = this.imageController.$process($container);

	return imageCount;
}
BaseController.prototype.getImageController = function(){
	return this.imageController;
}
BaseController.prototype.isDevice = function(device){
	var isDeviceVisible = $("body").find("." + device).is(":visible");
	return isDeviceVisible;
}
BaseController.prototype.isMobile = function(){
	var isMobile = this.isDevice('mobile');
	return isMobile;
}
BaseController.prototype.off = function(onComplete){
	return true;
}

BaseController.prototype.offMain = function(onComplete){
	//TODO - get this in an array powering all pages
	const themes = {
		"": 					"primary",
		"property-search": 		"primary",
		"property-management": 	"primary",
		"about": 				"quinary",
		"client-testimonials": 	"tertiary",
		"contact": 				"quinary",
		"testimonials": 		"quinary",
		"case-studies":			"quinary",
		"press-commentary": 	"quinary",

	}

	const bc = themes[nav.getState().nextParts[0]] ?? "primary";
	this.$cover.removeClass((index, className) => (className.match(/\btheme-[a-z]+/)||[])[0]).addClass("theme-"+bc).stop().animate({opacity:1},{duration:500, complete: () => {
		onComplete();
	}})
	return false;
}